import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import { PlatformConfigProvider } from "@/lib/platformConfig";
import ScrollToTop from "@/components/layout/ScrollToTop";
import MainLanding from "@/pages/MainLanding";
import ModuleLandingRouter from "@/pages/ModuleLandings";
import EngineeringMainPage, { EngineeringServiceRouter } from "@/pages/EngineeringSite";
import CorporateMainPage, { CorporatePillarRouter } from "@/pages/CorporateSite";
import AboutRouter from "@/pages/AboutSite";
import Login from "@/pages/Login";
import ControlPanel from "@/pages/ControlPanel";
import ModuleDashboard from "@/pages/ModuleDashboard";
import ModuleRecords from "@/pages/ModuleRecords";
import ModuleSubRecords from "@/pages/ModuleSubRecords";
import HRShell from "@/pages/HRShell";
import EmployeeSelfService from "@/pages/EmployeeSelfService";
import ChangePassword from "@/pages/ChangePassword";
import OrgUsers from "@/pages/OrgUsers";
import PaymentNotices from "@/pages/PaymentNotices";
import Settings from "@/pages/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PlatformConfigProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
            <Route path="/" element={<MainLanding />} />
            {/* Module-specific landing pages */}
            <Route path="/m/:slug" element={<ModuleLandingRouter />} />
            {/* Engineering Division — Olu-Akintade Computer & Electrical Works Engineering */}
            <Route path="/engineering" element={<EngineeringMainPage />} />
            <Route path="/engineering/:slug" element={<EngineeringServiceRouter />} />
            {/* ATTP Corporate Hub */}
            <Route path="/corporate" element={<CorporateMainPage />} />
            <Route path="/corporate/:slug" element={<CorporatePillarRouter />} />
            {/* About Us — sub-pages */}
            <Route path="/about" element={<Navigate to="/about/about-attp" replace />} />
            <Route path="/about/:slug" element={<AboutRouter />} />
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={
              <ProtectedRoute allowForcedChange>
                <ChangePassword />
              </ProtectedRoute>
            } />
            <Route path="/control-panel" element={<ProtectedRoute requireSuperAdmin><ControlPanel /></ProtectedRoute>} />
            {/* Employee self-service workspace for team_member role */}
            <Route path="/my-workspace" element={<ProtectedRoute><EmployeeSelfService /></ProtectedRoute>} />
            {/* HR has its own dedicated workspace */}
            <Route path="/dashboard/hr" element={<ProtectedRoute><HRShell /></ProtectedRoute>} />
            <Route path="/dashboard/:slug" element={<ProtectedRoute><ModuleDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/:slug/records" element={<ProtectedRoute><ModuleRecords /></ProtectedRoute>} />
            <Route path="/dashboard/:slug/sub/:sub" element={<ProtectedRoute><ModuleSubRecords /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><OrgUsers /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><PaymentNotices /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BrowserRouter>
        </PlatformConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
